namespace Matrix.Data {
    export interface HelpTextRow {
        Topic?: string;
        NoteText?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace HelpTextRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'Topic';
        export const localTextPrefix = 'Data.HelpText';
        export const deletePermission = 'DataAdmin:HelpText';
        export const insertPermission = 'DataAdmin:HelpText';
        export const readPermission = 'Read:HelpText';
        export const updatePermission = 'DataAdmin:HelpText';

        export declare const enum Fields {
            Topic = "Topic",
            NoteText = "NoteText",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
